import React from "react";

export default function About() {
  return (
    <div className="content-container about-container">
      <div className="column-about about-text-col">
        <h1>Hey there, I'm Roman</h1>
        <div>
          <p>
            I'm a Tech lead and Product Manager based in Graz, Austria. After completing my studies at Graz University of Technology,
            I had the opportunity to work in different fields as a software engineer, product owner and tech lead.
            While I am fascinated by the wide range of possibilities in software engineering, I am particularly interested in web development and data analytics.
          </p>
          <p>
            In my free time, I enjoy climbing, hiking, running, or playing a game of chess. Over the past few years,
            sport climbing has become one of my biggest passions, and I now teach climbing at
            the <a href="https://www.c-a-c.at/">city adventure center</a> in Graz.
          </p>
          <p>
            Currently, I work as a Product Manager, where I combine my technical background with a strong focus on leadership and delivering customer value. 
            While my role has shifted towards strategic thinking, mentoring, and team coordination, I continue to enjoy building, fixing, and experimenting.           
          </p>
        </div>
      </div>
    </div>
  );
}
